/* tslint:disable */
/* eslint-disable */
export enum ApprovalRequestState {
  Pending = 'pending',
  Accepted = 'accepted',
  Declined = 'declined',
  Withdrawn = 'withdrawn'
}
